import { useNavigate } from "react-router-dom";
import { classNames } from "../utils";

export enum ReportEntryStyle {
  TEXT = "TEXT",
  BOLD_TEXT = "BOLD_TEXT",
  THRESHOLD = "THRESHOLD",
}

interface EntryProps {
  text: string;
  style?: ReportEntryStyle;
  status?: string;
  day?: Date | number;
  isManual?: boolean;
  clickable?: boolean;
}

const DashboardEntry = ({
  text,
  style,
  status,
  day,
  isManual,
  clickable,
}: EntryProps) => {
  const navigate = useNavigate();
  return (
    <div
      className={classNames(
        "flex px-3 flex-1 items-center justify-center text-black ",
        isManual ? "bg-blue-50" : "",
        style === ReportEntryStyle.BOLD_TEXT ? "font-semibold" : "",
        clickable ? "cursor-pointer" : ""
      )}
      onClick={() =>
        clickable
          ? navigate(
              `status/${status}?daysDue=${
                day instanceof Date ? day.toISOString().split("T")[0] : day
              }`
            )
          : ""
      }
    >
      {text}
    </div>
  );
};

export default DashboardEntry;
